export default __webpack_public_path__ + "static/media/ic-schedule-inactive.f8241e52.svg";